<template>
  <div v-if="tab"
       :class="['action-tab', tab.tabClass, isTabOpen ? 'opened' : 'closed', { hide: hideTab }]"
       @click="$emit('toggleTab', tab.tabType)">
    <div v-if="mediaCounter" class="media-counter">{{mediaCounter}}</div>
    <svg :viewBox="tab.viewbox" class="sb-icon">
      <use :xlink:href="`#${tab.icon}`"></use>
    </svg>
  </div>
</template>

<script>

  export default {
    props: {
      hideTab: [Boolean, Number, String],
      isTabOpen: Boolean,
      mediaCounter: [Number, String],
      tab: Object,
    },

    name: 'SmsActionTab',

    watch: {
      hideTab: function () {
        if (!!this.hideTab) { this.$emit('toggleTab', this.tab.tabType, true) }
      }
    }
  }
</script>